import React, { Component } from 'react';
import propTypes from 'prop-types';
import SearchReferenceModal from '../../../../../editJournal/addUpdateReference/searchReferenceModal';
import ManualAddModal from '../../../../../editJournal/addUpdateReference/manualAddModal';

class References extends Component {
  state = {};

  render() {
    const {
      manualShow,
      show,
      closeManualReferenceModal,
      closeReferenceModal,
      editor,
    } = this.props;

    const {
      value: { selection },
    } = editor;

    return (
      <>
        <SearchReferenceModal
          isModalOpen={show}
          closeModal={closeReferenceModal}
          selection={selection}
          editor={editor}
        />

        <ManualAddModal
          isModalOpen={manualShow}
          closeModal={closeManualReferenceModal}
          selection={selection}
          editor={editor}
        />
      </>
    );
  }
}

References.propTypes = {
  editor: propTypes.shape({
    resolveController: propTypes.func,
  }).isRequired,
  show: propTypes.bool.isRequired,
  closeReferenceModal: propTypes.func.isRequired,
  closeManualReferenceModal: propTypes.func.isRequired,
  manualShow: propTypes.bool.isRequired,
};

export default References;
